const initialState = "dark";

const text = (state = initialState, action) => {
    switch (action.type) {
        case 'HANDLE_TEXT':
            state = action.payload.text
            return state;

        default:
            return state;
    }
};

export default text;